module.exports = __webpack_public_path__ + "img/step1.1215db82.webp";